"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antDesignVue = require("ant-design-vue");
var _ExportBlobToExcel = _interopRequireDefault(require("../ExportBlobToExcel"));
var _default = exports.default = {
  name: 'CustomImportDataModal',
  // 导入数据弹框
  components: {
    ExportBlobToExcel: _ExportBlobToExcel.default
  },
  props: {
    afterClose: {
      type: Function,
      default: undefined
    },
    value: {
      type: Boolean,
      default: false
    },
    // 模态框的标题
    title: {
      type: String,
      default: '导入数据'
    },
    width: {
      type: Number,
      default: 680
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    // 显示在上传文件控件下方的提示语
    tips: {
      type: String,
      default: ''
    },
    titles: {
      type: Array,
      default: () => {
        return ['下载导入模板', '将需要导入的信息填入模板', '填写相应信息后上传模板'];
      }
    },
    demos: {
      type: Array,
      default: () => {
        return [
          // 格式如下
          // { label: '姓名', value: '张三' },
          // { label: '固定工资', value: '3000' },
          // { label: '绩效基数', value: '5000' }
        ];
      }
    },
    // 导出组件的配置
    exportOptions: {
      type: Object,
      default: () => {
        return {
          // method: getDataDownload, // 获取模板链接的接口方法
          // params: { id: '1407940504229818369' } // 请求参数
        };
      }
    },
    // 上传组件的配置
    uploadOptions: {
      type: Object,
      default: () => {
        return {
          action: '' // mode为server时该值为必填，且必须携带“/api”前缀，如：/api/v1/plan/target/set/month/template/upload
        };
      }
    },
    // 点击“确定”按钮时调用的方法
    saveDataFun: {
      type: Function,
      default: undefined
    },
    // 点击“确定”按钮时调用的方法的额外参数
    saveDataParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 下载错误数据时调用的方法，如果没有配置该值则不显示下载错误数据的弹框，可根据实际业务监听 fail 事件进行其他处理
    downloadErrorDataFun: {
      type: Function,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      confirmLoading: false,
      visible: false,
      fileList: [],
      // 上传组件默认配置
      defaultUploadOptions: {
        accept: '.xls,.xlsx',
        limit: 1,
        mode: 'server'
      }
    };
  },
  watch: {
    value(value) {
      this.visible = value;
      this.$emit('update:loading', false);
    },
    visible(value) {
      this.fileList.length = 0;
      this.$emit('input', value);
    },
    loading(value) {
      this.confirmLoading = value;
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
      this.visible = false;
    },
    onConfirm() {
      if (this.fileList.length === 0) {
        this.$message.warning('请先上传文件');
        return;
      }
      const {
        status,
        response
      } = this.fileList[0];
      if (status === 'uploading') {
        this.$message.warning('文件正在上传，请稍后...');
        return;
      }
      if (status === 'error') {
        this.$message.error(response);
        return;
      }
      if (this.saveDataFun) {
        // 点击“确定”按钮调用传入的方法
        this.saveData(response.data.requestId);
      } else {
        // 或者触发“ok”事件，由具体业务进行后续处理
        this.$emit('ok', ...this.fileList); // 最终返回一个文件对象
      }
    },
    async saveData(requestId) {
      try {
        this.confirmLoading = true;

        // res { requestId, errorNum, successNum }
        const res = await this.saveDataFun({
          requestId,
          ...this.saveDataParams
        });
        if (res.errorNum === 0) {
          this.successTip(res);
          this.visible = false;
        } else {
          // 只有配置了saveDataFun属性，且导入失败时才会触发fail事件
          this.$emit('fail', res);
          this.downloadErrorDataFun && this.downloadErrorData(res);
        }
        this.confirmLoading = false;
      } catch (error) {
        this.confirmLoading = false;
      }
    },
    downloadErrorData({
      requestId,
      errorNum,
      successNum
    }) {
      const h = this.$createElement;
      // 由于历史原因，部分旧接口没有返回successNum字段，在此做兼容处理
      _antDesignVue.Modal.confirm({
        title: '导入结果',
        content: () => h("div", {
          "class": "m-p-t-8"
        }, [successNum !== undefined ? h("div", ["\u6210\u529F\u5BFC\u5165\u6570\u636E\uFF1A", h("span", {
          "class": "m-type-primary m-m-h-4"
        }, [successNum]), "\u6761"]) : '部分数据导入成功', h("div", {
          "class": "m-m-v-8"
        }, ["\u56E0\u6821\u9A8C\u4E0D\u901A\u8FC7\u65E0\u6CD5\u5BFC\u5165\u7684\u6570\u636E\uFF1A", h("span", {
          "class": "m-type-primary m-m-h-4"
        }, [errorNum]), "\u6761"]), h("div", {
          "class": "m-type-error"
        }, ["\u4E0D\u7B26\u5408\u5BFC\u5165\u89C4\u5219\u7684\u6570\u636E\uFF0C\u53EF\u4E0B\u8F7D\u5E76\u4FEE\u6539\u540E\u91CD\u65B0\u5BFC\u5165"])]),
        icon: () => h("a-icon", {
          "style": "color:#2483FF",
          "attrs": {
            "type": "exclamation-circle"
          }
        }),
        cancelText: '关闭',
        okText: '下载错误数据',
        onCancel: () => {
          this.visible = false;
          if (successNum > 0 || successNum === undefined) {
            this.successTip({
              requestId,
              errorNum,
              successNum
            });
          }
        },
        onOk: async () => {
          const {
            data,
            headers
          } = await this.downloadErrorDataFun({
            requestId
          }, {
            responseType: 'blob',
            originalData: true
          });
          const contentDisposition = headers['content-disposition'] || '';
          const arr = contentDisposition.match(/filename=(\S*)/);
          const filename = arr ? arr[1] : `${new Date().toLocaleDateString().replace(/\//g, '')}.xlsx`;
          this.$m.file.downloadFile(data, filename);
        }
      });
    },
    // 只有配置了saveDataFun属性且导入成功，或者同时配置了downloadErrorDataFun属性且点击了“取消”按钮时才会触发success事件
    successTip({
      requestId,
      errorNum,
      successNum
    }) {
      this.$emit('success', {
        requestId,
        errorNum,
        successNum
      });
      let msg = '全部导入成功';
      if (errorNum !== 0) {
        msg = successNum !== undefined ? `导入结果：成功 ${successNum} 条；失败 ${errorNum} 条` : `导入结果：失败 ${errorNum} 条；其余导入成功`;
      }
      this.$message.success(msg);
    }
  }
};